import { Input as AntInput } from "antd"
import { TOnChangeInput } from "types/default.type"
import type { SizeType } from "antd/es/config-provider/SizeContext"
import { InputProvider } from "components/providers/Input.provider"

type Props = {
	onChange?: (args: TOnChangeInput) => void
	onPressEnter?: () => void
	onBlur?: () => void
	width?: string
	size?: SizeType
	disabled?: boolean
	value?: string
	className?: string
	placeholder?: string
	status?: "error" | "warning"
}

export const Input = ({
	width = "100%",
	onChange,
	onPressEnter,
	onBlur,
	size = "large",
	disabled = false,
	value,
	className,
	placeholder,
	status,
}: Props) => {
	return (
		<div data-testid="input">
			<InputProvider>
				<AntInput
					placeholder={placeholder}
					style={{ width: width }}
					onChange={onChange}
					onPressEnter={onPressEnter}
					onBlur={onBlur}
					size={size}
					disabled={disabled}
					value={value}
					className={className}
					status={status}
				/>
			</InputProvider>
		</div>
	)
}
